
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/itsm-self-service-portal",
      function () {
        return require("private-next-pages/solutions/itsm-self-service-portal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/itsm-self-service-portal"])
      });
    }
  